"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'block',
        fill: theme.indigo1
    },
    type: {
        '&[data-fill=true]': {
            fill: 'currentColor'
        }
    }
});
//# sourceMappingURL=logo.text.style.js.map